import { ContentView } from '../../../../api/client'
import { ConditionalCopyToClipboard, CopyToClipboardWrapper } from '../../../CopyToClipboard'
import ProfileId from '../../../profile/ProfileId'
import { ContentMetadataRow, SectionHeader } from './ContentMetadataModal'

type Props = {
    content: ContentView
}

export default function ContentMetadataAuthor({ content }: Props) {
    return (
        <div>
            <SectionHeader title="Author details" />
            <div className="mt-2">
                <dl>
                    <ContentMetadataRow
                        title="Platform account ID:"
                        zebra_dark={true}
                        children={<ProfileId content={content} />}
                    />
                    <ContentMetadataRow
                        title="Username:"
                        zebra_dark={false}
                        children={
                            <ConditionalCopyToClipboard
                                text={content.serviceAuthorName}
                                fallback="This field is not set"
                            />
                        }
                    />
                    <ContentMetadataRow
                        title="Display name:"
                        zebra_dark={true}
                        children={
                            <ConditionalCopyToClipboard
                                text={content.serviceAuthorDisplayUsername}
                                fallback="This field is not set"
                            />
                        }
                    />
                    <ContentMetadataRow
                        title="Profile URL:"
                        zebra_dark={false}
                        children={
                            content.socialMediaAuthorLink ? (
                                <CopyToClipboardWrapper
                                    children={
                                        <a
                                            href={content.socialMediaAuthorLink}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="text-arwen-700 hover:text-arwen-800 underline"
                                        >
                                            {content.socialMediaAuthorLink}
                                        </a>
                                    }
                                    text={content.socialMediaAuthorLink}
                                />
                            ) : (
                                'This field is not set'
                            )
                        }
                    />
                    <ContentMetadataRow
                        title="Arwen internal profile ID:"
                        zebra_dark={true}
                        children={
                            <ConditionalCopyToClipboard
                                text={content.authorProfileId}
                                fallback="This field is not set"
                            />
                        }
                    />
                </dl>
            </div>
        </div>
    )
}
